<nav
    class="navbar navbar-expand-lg navbar-light bg-light"
    [class.active]="classApplied"
    ngStickyNav
    stickyClass="sticky-box-shadow"
    ngStickyNav
>
    <div class="container">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/logo.svg" alt="logo" />
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr me-auto">
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('home')"
                        >الرئيسية</span
                    >
                </li>
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('about')"
                        >لماذا تختارنا</span
                    >
                </li>
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('services')"
                        >خدماتنا</span
                    >
                </li>
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('screenshots')"
                        >شاشات التطبيق</span
                    >
                </li>
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('howToUse')"
                        >كيف تعمل</span
                    >
                </li>
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('faqs')"
                        >الأسئلة الشائعة</span
                    >
                </li>
                <li class="nav-item">
                    <span class="nav-link" (click)="onClick('testimonials')"
                        >آراء عملائنا</span
                    >
                </li>
            </ul>
            <ul class="navbar-nav me-auto for-responsive">
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('home')"
                        >الرئيسية</span
                    >
                </li>
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('about')"
                        >لماذا اخترتنا</span
                    >
                </li>
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('services')"
                        >خدماتنا</span
                    >
                </li>
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('screenshots')"
                        >شاشات التطبيق</span
                    >
                </li>
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('howToUse')"
                        >كيف تعمل</span
                    >
                </li>
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('faqs')"
                        >الأسئلة الشائعة</span
                    >
                </li>
                <li class="nav-item">
                    <span
                        class="nav-link"
                        (click)="toggleClass(); onClick('testimonials')"
                        >اراء عملائنا</span
                    >
                </li>
            </ul>
            <div class="navbar-btn">
                <a routerLink="/">تحميل Trackid</a>
            </div>
        </div>
    </div>
</nav>
